<template>
  <div class="selector-site-obj-">
    <multiselect
      v-model="selected"
      @input="onChange"
      :options="options"
      :custom-label="labelSite"
      :multiple="isMulti == true ? true : false"
      selectLabel=""
      selectedLabel="«"
      deselectLabel=""
      :allowEmpty="allowEmpty"
      :preselectFirst="true"
      :loading="isLoading"
      :label="$t('Nome')"
      track-by="id"
      :disabled="isDisabled"
      placeholder=""
      :required="isRequired"
    >
      <template slot="noResult">
        <span>{{ $t('Nenhum elemento encontrado') }}.</span>
      </template>
      <template slot="noOptions">
        <span>{{ $t('Nenhum dado foi retornado') }}.</span>
      </template>
      <template slot="placeholder">
        <span>{{ $t(emptyLabel) }}</span>
      </template>
    </multiselect>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'alreadySelected',
    'allowEmpty'
  ],

  data() {
    return {
      selected: '',
      options: [],
      isLoading: false
    };
  },

  methods: {
    onChange(e) {
      this.$emit('input', e.id);
      if (e == null) {
        this.$emit('selectChange', 'site', null);
        return;
      }
      this.$emit('selectChange', 'site', e.id);
      this.$emit('focus');
    },
    labelSite({ nome_fantasia }) {
      return nome_fantasia;
    },
    setValue(value) {
      if (this.alreadySelected && this.alreadySelected.length && this.isMulti) {
        this.selected = this.options.filter((option) => this.alreadySelected.includes(option.id));
      } else if (value) {
        if (typeof value == 'number') {
          this.selected = this.options.find((option) => option.id === value);
        } else {
          this.selected = this.options.find((option) => option.id === value.id);
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    },
    setOptions() {
      this.isLoading = true;
      this.$atenaList
        .getCommon('affiliateSites', { id_empresa: this.$util.getIdEmpresa() })
        .then((res) => {
          this.options = [];
          if (this.includeAll) {
            this.options = [{ id: null, nome_fantasia: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);

          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$util.formWarn({
            msgTitle: this.$t('Atenção'),
            msgContent: `${error.code} - ${this.$t(error.message)}`,
            msgTranslate: false
          });
        });
    }
  },
  created() {
    this.setOptions();
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>

<style lang="scss">
.selector-site-obj- {
  .multiselect:not(.multiselect--active) {
    .multiselect__tags {
      display: flex !important;
    }
  }
  .multiselect__tag {
    background: #26b4ff;
  }
}
</style>
